import { Routes } from '@angular/router';
import { LayoutComponent } from '@pages/layout/layout.component';
import { AuthGuard } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import ('@pages/layout/layout.routing').then((r) => r.LayoutRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/auth.routing').then((r) => r.AuthRouting),
  },
  {
      path: 'analisis-avanzado/resultados/:analysisId',
      loadComponent:() => import('@pages/home/pages/advanced-credit-analysis/pages/query-result/components/home/home.component').then((c) => c.HomeComponent),
      // canActivate: [AuthGuard]
    },
    {
    path: '404',
      loadComponent: () => import('@pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
    },
    {
      path: '**',
      redirectTo: '/404',
      pathMatch: 'full',
    },

];


